import React from 'react';

const JS_RegExp_Objects = () => {
  return (
    <div >
      <h1>JS_RegExp_Objects</h1>
      <p>Placeholder component for: "JS RegExp Objects"</p>
    </div>
  );
};

export default JS_RegExp_Objects;
